import { Button, Heading, Paragraph, Stack, Text } from '@customerio/pluma-components/react';
import { LottieAnimation } from './lottie-animation';
import * as styles from '../index.css';

const EVENT_CTA_URL =
  'https://customer.io/platform/agent?utm_medium=inbound&utm_source=customer.io&utm_campaign=q22026_mega_gtm&utm_content=log-in_promo&utm_term=demand%20gen';

// Lazy-loaded so the ~130KB animation stays out of the initial login bundle.
const loadSearchAnimation = () => import('@/assets/animations/referral/search-animation.json');

/**
 * Marketing splash shown beside the login form on desktop. Ported from the
 * Ember `ReferralSplash` — Lottie search animation, headline, copy, and CTA.
 * Campaign copy/links mirror the current Ember source.
 */
export function ReferralSplash() {
  return (
    <Stack className={styles.referralPanel} gap="200" alignInline="center" data-test-referral-splash-desktop>
      <LottieAnimation load={loadSearchAnimation} className={styles.referralAnimation} />
      <Heading level="2" weight="semibold" className={styles.referralHeadline}>
        Our biggest launch <Text className={styles.referralHighlight}>ever</Text>.
      </Heading>
      <Paragraph size="l" color="invert">
        Don't settle for advice. Let your agent tackle the tedious.
      </Paragraph>
      <Button
        href={EVENT_CTA_URL}
        isExternal={true}
        variant="primary"
        mt="200"
        className={styles.referralCtaButton}
        data-test-referral-cta
      >
        Meet your Agent
      </Button>
    </Stack>
  );
}
